import { Experiment } from './graphQlExperimentsWhitelist'

const currentDate = new Date()
currentDate.setFullYear(currentDate.getFullYear() + 1)

export const mockWhitelist: Array<Experiment> = [
  {
    key: 'graphql-experiment-e2e-test',
    expiry: currentDate,
  },
  {
    key: 'graphql-log-global-e2e-test',
    expiry: currentDate,
    logGlobally: true,
  },
  {
    key: 'customer-entity-test',
    expiry: currentDate,
  },
]
